/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { UserForOrganizationAdminRequest } from '../../models/user-for-organization-admin-request';

export interface PutAdministrationOrganizationUser$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;

/**
 * The user key
 */
  userKey: KeyType;
      body: UserForOrganizationAdminRequest
}

export function putAdministrationOrganizationUser(http: HttpClient, rootUrl: string, params: PutAdministrationOrganizationUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putAdministrationOrganizationUser.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('userKey', params.userKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putAdministrationOrganizationUser.PATH = '/administration/organizations/{organizationKey}/users/{userKey}';
